define('controller/people/disclosures.list.controller',['require','exports','module','fukit/fukit','model/disclosure.detail.model','model/disclosure.model','model/template.model','fukit/fukit','model/disclosure.documents.model','view/people/disclosures.list.page.view','backbone.radio','jquery','underscore','disclosures'],function(require, exports, module) {
  //prettier-ignore
  var BaseController          = require('fukit/fukit').BaseController,
      DisclosureDetailModel   = require('model/disclosure.detail.model'),
      DisclosureModel         = require('model/disclosure.model'),
      TemplateModel           = require('model/template.model'),
      ProductModel            = require('fukit/fukit').ProductModel,
      DocumentsModel          = require('model/disclosure.documents.model'),
      DisclosuresListPageView = require('view/people/disclosures.list.page.view'),
      Radio                   = require('backbone.radio'),
      $                       = require('jquery'),
      _                       = require('underscore'),
      disclosures             = require('disclosures');

  var DisclosuresListController = BaseController.extend({
    radioRequests: {
      'controllers DisclosuresListController': '@constructor',
    },

    pageView: DisclosuresListPageView,

    resources: {
      disclosureModel: {
        model: DisclosureModel,
      },
      disclosureCollection: {
        collection: DisclosureDetailModel.Collection,
        sort: {
          field: 'createDate',
          direction: 'descending',
        },
      },
      templateCollection: {
        collection: TemplateModel.Collection,
        filters: [
          {
            field: 'active',
            value: true,
          },
        ],
      },
      productCollection: {
        collection: ProductModel.Collection,
      },
      disclosureTypeCollection: {
        collection: Backbone.Collection,
        data: disclosures.data,
      },
    },

    onStart: function() {
      var currentProductNameHeader = _.isUndefined($.ajaxSettings.headers)
        ? false
        : $.ajaxSettings.headers['Product-Name'];
      var userPrincipalModel = this.getResource('userPrincipalModel');

      this.setProductNameHeader('COI');

      //get a list of disclosures for the current user
      this.fetchResource('disclosureCollection');

      // get the list of available templates
      this.fetchResource('templateCollection');
      this.fetchResource('productCollection');

      if (currentProductNameHeader) {
        this.setProductNameHeader(currentProductNameHeader);
      } else {
        delete $.ajaxSettings.headers['Product-Name'];
      }

      // Documents for Disclosures

      var controller = this;

      this.listenTo(this.getResource('disclosureCollection'), 'sync', function(collection) {
        var modelsArray = collection.models;
        for (var i = 0; i < modelsArray.length; i++) {
          var disclosureId = modelsArray[i].get('id');
          var model = modelsArray[i];

          model.set('documents', []);

          var documentsCollection = new DocumentsModel.Collection();

          documentsCollection.filters.addFilterWithField({ name: 'attachmentPoint' }).equals(disclosureId);

          if (documentsCollection) {
            documentsCollection
              .fetch()
              .promise()
              .then(function(result) {
                var documents = result._embedded.fileDbs;
                if (documents) {
                  var filteredModels = _.where(documents, { type: 'COI Management Plan' });
                  var disclosuresList = controller.resources.disclosureCollection.models;
                  var targetModel;

                  for (var c = 0; c < disclosuresList.length; c++) {
                    var targetId = documents[0].attachmentPoint;

                    if (targetId == disclosuresList[c].get('id')) {
                      targetModel = disclosuresList[c];
                    }
                  }
                  targetModel.set('documents', filteredModels);
                }
              })
              .bind(this);
          }
        }
      });
    },

    setProductNameHeader: function(productName) {
      $.ajaxSetup({ headers: { 'Product-Name': productName } });
    },
  });

  module.exports = DisclosuresListController;
});

